// Pipeline Stage Types for frontend
export interface PipelineStageDto {
  id: string;
  name: string;
  displayName: string;
  status: PipelineStageStatus;
  startTime?: string;
  finishTime?: string;
  order: number;
  dependsOn: string[];
  stageType: PipelineStageType;
}

export enum PipelineStageStatus {
  NotStarted = 'notStarted',
  InProgress = 'inProgress',
  Succeeded = 'succeeded',
  Failed = 'failed',
  Canceled = 'canceled',
  Skipped = 'skipped',
  PartiallySucceeded = 'partiallySucceeded',
  Waiting = 'waiting'
}

export enum PipelineStageType {
  Build = 'build',
  Test = 'test',
  Deploy = 'deploy',
  Approval = 'approval',
  Gate = 'gate',
  Other = 'other'
}

export interface PipelineStagesDto {
  buildId: number;
  pipelineName: string;
  stages: PipelineStageDto[];
  overallStatus: PipelineStageStatus;
}